export const environment = {
    release_version: "VAULT-26-06-7.1.0",    // Deployed release-vault-v07.2026 branch to DEV on 15.06.2026 - VAULT-26-06-7.1.0
    base_URL: "https://bssdev-vault-pim-web-service.csi-nonprod.macmillan-learning.com/api/",    
    drillhole_cost: 0.3125,
    shrinkwrapping_Cost: 0.2250
};
